import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@app/config/routes";
import styles from "./NotFound.module.css";

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.notFoundCard}>
        <h1 className={styles.notFoundTitle}>404</h1>
        <h2 className={styles.notFoundSubtitle}>Página no encontrada</h2>
        <p className={styles.notFoundMessage}>
          Lo sentimos, la página que estás buscando no existe o ha sido movida.
        </p>
        <button
          onClick={() => navigate(ROUTES.HOME)}
          className={styles.homeButton}
        >
          Volver al inicio
        </button>
      </div>
    </div>
  );
};
